var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiInputAdornment from '@mui/material/InputAdornment';
import { styled } from '../../styled';
import { Text } from '../../text';
export var inputAdornmentComponentName = 'QuantumInputAdornment';
var Root = styled(MuiInputAdornment, { name: inputAdornmentComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return __assign({}, (ownerState.align === 'top' && {
        alignSelf: 'flex-start',
        marginTop: theme.spacing(2.5),
    }));
});
export var InputAdornment = React.forwardRef(function (props, ref) {
    var _a = props.align, align = _a === void 0 ? 'center' : _a, children = props.children, disableTypography = props.disableTypography, adornmentProps = __rest(props, ["align", "children", "disableTypography"]);
    return (React.createElement(Root, __assign({ ref: ref, ownerState: { align: align }, disableTypography: true }, adornmentProps), typeof children === 'string' && !disableTypography ? (React.createElement(Text, { color: "textSecondary", variant: "body2" }, children)) : (children)));
});
